import { CircularProgress, Stack } from '@mui/material';

export function PageLoader() {
  return (
    <Stack
      role="status"
      aria-label="Loading"
      justifyContent="center"
      alignItems="center"
      sx={{ height: '100vh', width: '100%' }}
    >
      <CircularProgress />
    </Stack>
  );
}
